<div class="expanded-section{{feel ? ' -feel-'+feel:''}}">
    <div class="expanded-section__wrapper wrapper">
        <ng-content></ng-content>
    </div>
</div>